import { ReactElement } from 'react'

import { Select } from 'antd'

import { ConditionalWrapper } from 'components/ConditionalWrapper'
import { ToolTip } from 'components/ToolTip'

import { FormikWithCustomHandlersProps } from '../propTypes'
import withCustomHandlers from '../withCustomHandlers'

type FormikSelectProps<V> = FormikWithCustomHandlersProps<V> & {
    tooltipPlacement: 'top' | 'bottom' | 'left' | 'right'
    tooltipTitle: string
}

function FormikSelect<V>({
    field: { value },
    form,
    handleChange,
    handleBlur,
    handleClick,
    tooltipPlacement = 'bottom',
    tooltipTitle,
    ...props
}: FormikSelectProps<V>): ReactElement {
    return (
        <ConditionalWrapper
            condition={Boolean(tooltipTitle)}
            wrapper={(children) => (
                <ToolTip
                    title={tooltipTitle}
                    arrow={{ pointAtCenter: true }}
                    placement={tooltipPlacement}
                >
                    {children}
                </ToolTip>
            )}
        >
            <Select
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                {...props}
            />
        </ConditionalWrapper>
    )
}

export default withCustomHandlers(FormikSelect)
